import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function ProductDetail() {
  const { slug } = useParams();
  return (
    <>
      <Helmet><title>{slug} | Cool Wave</title></Helmet>
      <section className="container py-16">
        <h1 className="mb-2 text-3xl font-bold">{slug}</h1>
        <p className="text-body">Product detail page — coming soon.</p>
      </section>
    </>
  );
}
